import styled from 'styled-components'

export const StyledReceiptTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
